module.exports = __webpack_public_path__ + "static/media/banner_car.4479d9df.png";